import { render, staticRenderFns } from "./SubirResolucion.vue?vue&type=template&id=5ff31d44&"
import script from "./SubirResolucion.vue?vue&type=script&lang=js&"
export * from "./SubirResolucion.vue?vue&type=script&lang=js&"
import style0 from "./SubirResolucion.vue?vue&type=style&index=0&id=5ff31d44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports